












// vendor
import { defineComponent, computed, ref, inject, PropType } from "@vue/composition-api";
// project
import { Gallery } from "@/psychlab/types/gallery";
import { ScriptableForm, FormProperty } from "@/components.generic/scriptable-form";

type GalleryProp = FormProperty&{
	key:keyof(Gallery)
};

export default defineComponent({
	props:{
		data:{
			type:Object as PropType<Gallery>,
			required:true,
		}
	},
	components:{
		ScriptableForm,
	},
	setup(p){

		const props = computed<GalleryProp[]>(() => {

			const r:GalleryProp[] = [
				{
					type:"toggle",
					key:"panorama",
					target:p.data,
					label:"Panorama",
					tooltip:"If enabled, items will be treated like panoramas and displayed in 360° view.",
					config:{
						onLabel:"Yes",
						offLabel:"No",
					}
				},
				{
					type:"toggle",
					key:"navPerItem",
					target:p.data,
					label:"Per Item Navigation",
					tooltip:"If enabled, the global navigation buttons will also cycle between items.",
					config:{
						onLabel:"On",
						offLabel:"Off",
					}
				},
				{
					type:"toggle",
					key:"showLabels",
					target:p.data,
					label:"Show Item Labels",
					tooltip:"The currently active item will have its label displayed beneath the thumbnails (ignored if thumbnails are hidden).",
					config:{
						onLabel:"Yes",
						offLabel:"No",
					},
					disabled:false,
				},
				// {
				// 	type:"toggle",
				// 	key:"shuffle",
				// 	target:p.data,
				// 	label:"Shuffle Items",
				// 	tooltip:"Item display order will be shuffled.",
				// 	config:{},
				// 	disabled:true,
				// },
				// {
				// 	type:"toggle",
				// 	key:"hideThumbnails",
				// 	target:p.data,
				// 	label:"Hide Thumbnails",
				// 	tooltip:"Thumbnail viewer will be disabled. Has no effect if feedback is disabled and per item navigation is turned off.",
				// 	config:{},
				// 	disabled:true,
				// },
				// {
				// 	type:"toggle",
				// 	key:"reverseMobileSources",
				// 	target:p.data,
				// 	label:"Reverse Mobile Sources",
				// 	tooltip:"Item sources will be loaded in reverse order on mobile devices.",
				// 	config:{
				// 		onLabel:"Yes",
				// 		offLabel:"No",
				// 	},
				// 	disabled:false,
				// },
			];
			return r;
		});

		return {
			props,
		};
	}
});

